import {
  setStatsDetailParams,
  statsDetailIdKey,
} from '@op/utils/storageUtils';
import { DetailPage } from '../types';
import { v4 as uuidv4 } from 'uuid';
import { JumpType, navigate } from '@home/utils/utils';
import { DBO_U } from '@op/utils/format';

type OptionsType = {
  history: any;
  path?: string;
  extra?: string;
  stats?: { [key: string]: any };
  action?: () => void;
  jumpType?: JumpType;
};
export function goToDetailAction(data: DetailPage, options: OptionsType) {
  const {
    action,
    history,
    path = '/opinion/Detail',
    extra = '',
    stats = {},
    jumpType = JumpType.HistoryPush,
  } = options || {};

  const downloadId = uuidv4();

  // 写入失败时safeSetItem内部会逐级清理并提示，此时无需继续跳转
  if (!setStatsDetailParams(data, downloadId)) return;

  const { pathname } = history.location || { pathname: '' };
  const { search } = window.location;
  const splitString = path?.includes('?') ? '&' : '?';
  // When opening in a new window, append redirect_path so the Detail page
  // can navigate back (history.goBack() won't work in a new window).
  const redirectParam =
    jumpType === JumpType.Window
      ? `&redirect_path=${encodeURIComponent(
          DBO_U.stripBasePath(pathname + search),
        )}`
      : '';
  const resolvedUrl = `${path}${splitString}${statsDetailIdKey}=${downloadId}${extra}${redirectParam}`;
  navigate(resolvedUrl, { jumpType, historyState: stats });
  action?.();
}
